import React from 'react';
import {useStyles} from "./MediaView.style";
import {Breakpoint} from 'react-socks';
import MediaViewProperties from "./MediaViewProperties";
import clsx from "clsx";


const ViewLarge: React.FC<MediaViewProperties> = ({
                                                      fullHeight = false,
                                                      fullWidth = false,
                                                      children
                                                  }) => {
    const classes = useStyles();
    const containerClasses = clsx(fullHeight && classes.full_height, fullWidth && classes.full_width);
    return (
        <Breakpoint className={containerClasses} customQuery="(min-width: 1061px)">
            {children}
        </Breakpoint>
    )
}
export default ViewLarge;